import type { Color } from '@ptml/design-system';
import type { ReactNode } from 'react';

export const RobotSignalVariantList = {
    GRADIENT_CARD: 'gradientCard',
    GRADIENT_OUTLINE: 'gradientOutline',
    GRADIENT_ICON_ONLY: 'gradientIconOnly',
    GRADIENT_SOLID: 'gradientSolid',
    SOLID_DARK: 'solidDark',
    SOLID_PURPLE: 'solidPurple',
} as const;

export type RobotSignalVariant =
    (typeof RobotSignalVariantList)[keyof typeof RobotSignalVariantList];

export type RobotSignalCardVariant =
    typeof RobotSignalVariantList.GRADIENT_CARD;

export type RobotSignalIconBadgeVariant = Exclude<
    RobotSignalVariant,
    RobotSignalCardVariant
>;

export const RobotSignalShapeList = {
    SQUARE: 'square',
    CIRCLE: 'circle',
} as const;

export type RobotSignalShape =
    (typeof RobotSignalShapeList)[keyof typeof RobotSignalShapeList];

export const RobotSignalGradientDirectionList = {
    LEFT_TO_RIGHT: 'to right',
    RIGHT_TO_LEFT: 'to left',
    TOP_TO_BOTTOM: 'to bottom',
    BOTTOM_TO_TOP: 'to top',
    TOP_LEFT_TO_BOTTOM_RIGHT: 'to bottom right',
    BOTTOM_RIGHT_TO_TOP_LEFT: 'to top left',
} as const;

export type RobotSignalGradientDirection =
    (typeof RobotSignalGradientDirectionList)[keyof typeof RobotSignalGradientDirectionList];

export type RobotSignalVariantToken = {
    background: (direction?: RobotSignalGradientDirection) => string;
    disabledBackground: string;
    iconColor: Color;
    disabledIconColor: Color;
    textColor: Color;
    disabledTextColor: Color;
};

export type RobotSignalGradientDefsProps = {
    /** @default 'to bottom right' - matches the original fixed diagonal. */
    direction?: RobotSignalGradientDirection;
};

export type RobotSignalBannerProps = {
    description: ReactNode;
    iconLabel: string;
    /** @default RobotSignalGradientDirectionList.BOTTOM_TO_TOP */
    gradientDirection?: RobotSignalGradientDirection;
    'data-testid'?: string;
};

export type RobotSignalBadgeProps = {
    text: string;
    iconLabel: string;
    variant?: RobotSignalVariant;
    'data-testid'?: string;
};

export type RobotSignalIconBadgeStyleProps = {
    $variant?: RobotSignalIconBadgeVariant;
    $shape?: RobotSignalShape;
    $disabled?: boolean;
    $gradientDirection?: RobotSignalGradientDirection;
};
